module.exports = __webpack_public_path__ + "static/img/09shoudao.ce940afd.gif";